import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import EmployeeListService from '../../services/EmployeeListService';
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        holidays: [],
        benefits: [],
        employeeMeta: [],
        tenantData:{},
        selectedEmployee: {},
        taxDetails:[],
        bankDetails:{},
        CPFAccounts:{},
        employeeDetails:{}
    },
    fieldConfig: [],
    fieldPermissions: []
};
export const fetchEmployee = createAsyncThunk('employee', async () => {
    let response ;
    if(EmployeeListService.filterArray && EmployeeListService.filterArray.length != 0) {
      response = await EmployeeListService.getFilterEmployee();
    } else {
      response = await EmployeeListService.getEmployeeByPage();
    }    
    return response;
});

export const fetchFilterEmployee = createAsyncThunk('employee', async () => {
  const response = await EmployeeListService.getFilterEmployee ();
  return response;
});

export const fetchHolidays = createAsyncThunk("holidays", async () => {
  const response = await EmployeeListService.getHolidays();
  return response;
});

export const fetchEmployeeMeta = createAsyncThunk("employeeMeta", async (countryCode) => {
  const response = await EmployeeListService.getEmployeeMeta(countryCode);
  return response;
});

export const fetchTenantData = createAsyncThunk("tenantData", async (countryCode) => {
  const response = await EmployeeListService.getTenantData(countryCode);
  return response;
});

export const fetchEmployeeDetails = createAsyncThunk("employeeDetails", async (userId) => {
  const response = await EmployeeListService.getEmployeeDetails(userId);
  return response;
});

export const fetchEmployeeTaxDetails = createAsyncThunk("employeeTaxDetails", async (params) => {
  const response = await EmployeeListService.getEmployeeTaxDetails(params);
  return response;
});

export const deleteEmployeeDetails = createAsyncThunk("deleteEmployeeDetails", async () => {
  return {};
});

export const updateEmployeeDetails = createAsyncThunk("updateEmployeeDetails", async (response) => {
  return response;
});

export const fetchContractor = createAsyncThunk("contractor", async () => {
  const response = await EmployeeListService.getContractorByPage();
  return response;
});

export const fetchBankDetails = createAsyncThunk("bankDetails", async (countryCode) => {
  const response = await EmployeeListService.getBankDetails(countryCode);
  return response;
});

export const fetchCPFAccount = createAsyncThunk("CPFAccounts", async () => {
  const response = await EmployeeListService.getCPFAAccounts();
  return response
});
  

export const fetchEmployeeListWithoutFilter = createAsyncThunk('employeeListDetails', async () => {
    const response = await EmployeeListService.getEmployeesWithoutPage();;
    return response;
});

export const fetchAddEmployeeConfig = createAsyncThunk('addEmployeeConfig', async () => {
  const response = await EmployeeListService.getAddEmployeeConfig();;
  return response;
});

export const fetchFieldPermissions = createAsyncThunk('roleFieldPermissions', async () => {
  const response = await EmployeeListService.getFieldPermissions();;
  return response;
});

export const fetchRolePermissions = createAsyncThunk('rolePermissions', async () => {
  const response = await EmployeeListService.getRolePermissions();;
  return response;
});

export const fetchPeopleUsersShortInfo = createAsyncThunk('peopleUsersShortInfo', async () => {
  const response = await EmployeeListService.getPeopleUsersShortInfo();;
  return response;
});

export const EmployeeSlice = createSlice({
    name: 'employee',
    initialState,
    reducers: {
        addEmployeeColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToEmployeeColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchEmployee.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchEmployee.fulfilled, (state, action) => {
            state.status = "idle";
            state.data = action.payload;
          })
          .addCase(fetchHolidays.pending, (state) => {
            state.formData.holidays = "loading";
          })
          .addCase(fetchHolidays.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.holidays = action.payload;
          })
          .addCase(fetchEmployeeMeta.pending, (state) => {
            state.formData.employeeMeta = "loading";
          })
          .addCase(fetchEmployeeMeta.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.employeeMeta = action.payload;
          })
          .addCase(fetchTenantData.pending, (state) => {
            state.formData.tenantData = "loading";
          })
          .addCase(fetchTenantData.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.tenantData = action.payload;
          })
          .addCase(fetchEmployeeDetails.pending, (state) => {
            state.formData.selectedEmployee = "loading";
          })
          .addCase(fetchEmployeeDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.selectedEmployee = action.payload;
          })
          .addCase(fetchEmployeeTaxDetails.pending, (state) => {
            state.formData.taxDetails = "loading";
          })
          .addCase(fetchEmployeeTaxDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.taxDetails = action.payload;
          })
          .addCase(deleteEmployeeDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.selectedEmployee = action.payload;
          })
          .addCase(updateEmployeeDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.selectedEmployee = action.payload;
          })
          .addCase(fetchContractor.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchContractor.fulfilled, (state, action) => {
            state.status = "idle";
            state.data = action.payload;
          })
          .addCase(fetchBankDetails.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchBankDetails.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.bankDetails = action.payload;
          })
          .addCase(fetchCPFAccount.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchCPFAccount.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.CPFAccounts = action.payload;
          })
          .addCase(fetchEmployeeListWithoutFilter.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchEmployeeListWithoutFilter.fulfilled, (state, action) => {
            state.status = "idle";
            state.formData.employeeDetails = action.payload;
          })
          .addCase(fetchAddEmployeeConfig.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchAddEmployeeConfig.fulfilled, (state, action) => {
            state.status = "idle";
            state.fieldConfig = action.payload;
          })
          .addCase(fetchFieldPermissions.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchFieldPermissions.fulfilled, (state, action) => {
            state.status = "idle";
            state.fieldPermissions = action.payload;
          })
          .addCase(fetchRolePermissions.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchRolePermissions.fulfilled, (state, action) => {
            state.status = "idle";
            state.rolePermissions = action.payload;
          })
          .addCase(fetchPeopleUsersShortInfo.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchPeopleUsersShortInfo.fulfilled, (state, action) => {
            state.status = "idle";
            state.usersShortInfo = action.payload;
          })
    }
});

export const { addEmployeeColumnConfig, addColumnToEmployeeColumnConfig } =
    EmployeeSlice.actions;

export const selectEmployee = (state) => {

    return state.employee.data
};

export const selectHolidays = (state) => {
  return state.employee.formData.holidays;
};

export const selectEmployeeMeta = (state) => {
  return state.employee.formData.employeeMeta;
};

export const selectTenanatData = (state) => {
  return state.employee.formData.tenantData;
};

export const selectEmployeeColumnConfig = (state) =>
    state.employee.columnConfig;

export const selectEmployeeData = (state) => {
  return state.employee.formData.selectedEmployee;
};

export const selectEmployeeTaxDetails = (state) => {
  return state.employee.formData.taxDetails;
};

export const selectBankDetails = (state) => {
  return state.employee.formData.bankDetails;
};

export const selectCPFAccounts = (state) => {
  return state.employee.formData.CPFAccounts;
};

export const selectEmployeeListWithoutLimit = (state) => {
    return state?.employee.formData.employeeDetails;
};

export const selectAddEmployeeConfig = (state) => {
	return state.employee.fieldConfig?.fieldConfigs || [];
};

export const selectRoleFieldPermissions = (state) => {
	return state.employee.fieldPermissions?.resp || [];
};

export const selectRolePermissions = (state) => {
	return state.employee.rolePermissions || [];
};

export const selectPeopleUsersShortInfo = (state) => {
	return state.employee.usersShortInfo;
};

export default EmployeeSlice.reducer;
